import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, CheckIcon, TruckIcon, MapPinIcon } from 'lucide-react';
import { ShopProduct } from '../data/shop';
import { formatPrice } from '../data/smaken';
import { useShop } from '../ShopContext';
import { Note, Stamp } from './Marks';
export function ShopCard({
  product
}: {
  product: ShopProduct;
}) {
  const {
    add
  } = useShop();
  const [added, setAdded] = useState(false);
  useEffect(() => {
    if (!added) return;
    const timer = window.setTimeout(() => setAdded(false), 1500);
    return () => window.clearTimeout(timer);
  }, [added]);
  return <article className="group flex h-full flex-col border-t-2 border-black pt-4" data-id="element-698" data-mp="1d48zws6aorau">
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-black/5" data-id="element-699" data-mp="18b64eehyj7s0">
        <img src={product.image} alt={product.name} loading="lazy" className={`h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03] ${product.inStock ? '' : 'opacity-45'}`} data-id="element-700" data-mp="kllltwppucj9" />
        {product.stamp && <Stamp className="absolute right-3 top-3 bg-papper" data-id="element-701" data-mp="3ewneop9n7tp7">{product.stamp}</Stamp>}
        {!product.inStock && <span className="absolute left-0 top-0 bg-black px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide2 text-papper" data-id="element-702" data-mp="3jqrnle2gybsx">
            Slut just nu
          </span>}
      </div>

      <div className="flex flex-1 flex-col pt-4" data-id="element-703" data-mp="2r22k58dxxue0">
        {product.placeSlug ? <Link to={`/plats/${product.placeSlug}`} className="text-[11px] font-bold uppercase tracking-wide2 text-blaa transition-colors duration-150 ease-out hover:text-rod" data-id="element-704" data-mp="2vzm7qywj3jim">
            {product.producer} · {product.city}
          </Link> : <span className="text-[11px] font-bold uppercase tracking-wide2 text-black/45" data-id="element-705" data-mp="f9niim9m87sv">
            {product.producer} · {product.city}
          </span>}

        <h3 className="mt-2 font-display text-2xl leading-tight" data-id="element-706" data-mp="2gc55db1nx3h3">{product.name}</h3>
        <Note className="mt-2 block !text-lg" data-id="element-707" data-mp="2cb346oo6qhch">{product.tip}</Note>
        <p className="mt-2 text-[0.95rem] leading-relaxed text-black/70" data-id="element-708" data-mp="2catel271yc7b">{product.description}</p>

        <p className="mt-3 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide2 text-black/45" data-id="element-709" data-mp="2qa2rnszyoq72">
          {product.shipping === 'frakt' ? <>
              <TruckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-710" data-mp="1xmygt7e6thnd" /> Skickas i hela Sverige
            </> : <>
              <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-711" data-mp="27bzxz0wgy52x" /> Hämtas i {product.city}
            </>}
        </p>

        <div className="mt-auto flex items-end justify-between gap-4 pt-5" data-id="element-712" data-mp="22l00nujftkzw">
          <p data-id="element-713" data-mp="1evfi3cr74pr5">
            <span className="font-display text-2xl" data-id="element-714" data-mp="1ev5nfbv7huf4">{formatPrice(product.price)}</span>
            <span className="ml-1.5 text-[11px] uppercase tracking-wide2 text-black/45" data-id="element-715" data-mp="19wvs919hetti">
              {product.unit}
            </span>
          </p>
          <button onClick={() => {
          add(product);
          setAdded(true);
        }} disabled={!product.inStock} aria-label={`Lägg ${product.name} i varukorgen`} className={`flex shrink-0 items-center gap-2 px-4 py-3 text-[11px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out disabled:cursor-not-allowed disabled:bg-black/15 disabled:text-black/40 ${added ? 'bg-skog text-papper' : 'bg-black text-papper hover:bg-blaa'}`} data-id="element-716" data-mp="3liek8yir2psq">
            {added ? <CheckIcon className="h-4 w-4" data-id="element-717" data-mp="3vakbg616h36v" /> : <PlusIcon className="h-4 w-4" data-id="element-718" data-mp="3v9hk5wzy0yqf" />}
            {added ? 'I korgen' : product.inStock ? 'Köp' : 'Slut'}
          </button>
        </div>
      </div>
    </article>;
}